/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'message_warning': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" _stroke="#000" stroke-linejoin="round" stroke-width="2" d="M23 17H11l-6 6v-6H1V1h22v16z"/><path pid="1" _fill="#000" d="M11.128 9L10.5 4h3l-.628 5h-1.744zM12 14a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/>'
  }
})
